import Close from "@mui/icons-material/Close";
import {
  Alert as MUIAlert,
  IconButton,
  Snackbar,
  SnackbarProps,
  styled,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import "./toast.scss";
import Typography from "../typography/typography";

interface IToast extends SnackbarProps {
  handleClose: () => void;
  type?: "normal" | "alert";
  handleUndo?: () => void;
}

const StyledAlert = styled(MUIAlert)(({ theme: { palette } }) => ({
  color: "white",
  height: "2.5rem",
  padding: "0rem 1rem",
  display: "flex",
  alignItems: "center",

  "&.MuiAlert-standardWarning": {
    backgroundColor: palette.theme?.error[600],
  },

  "&.MuiAlert-standardInfo": {
    backgroundColor: palette.theme?.secondary[900],
  },

  ".MuiAlert-action": {
    padding: "0rem",
    marginLeft: "0.5rem",
  },

  ".MuiAlert-icon": {
    marginRight: "0.5rem",
  },
}));

const Toast = (props: IToast) => {
  const {
    open,
    message,
    type = "alert",
    handleUndo,
    handleClose,
    ...rest
  } = props;

  const action = (
    <>
      {handleUndo ? (
        <Typography
          className="toast-undo"
          type="s4"
          color={type === "normal" ? "theme.primary.600" : "white"}
          onClick={handleUndo}
        >
          Undo
        </Typography>
      ) : (
        <IconButton color="inherit" className="icon" onClick={handleClose}>
          <Close fontSize="inherit" />
        </IconButton>
      )}
    </>
  );

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={300000}
        onClose={handleClose}
        {...rest}
      >
        <StyledAlert
          action={action}
          onClose={handleClose}
          severity={type === "normal" ? "info" : "warning"}
          icon={
            type === "normal" ? (
              <CheckCircleOutlineIcon htmlColor="white" className="icon" />
            ) : (
              <WarningAmberIcon htmlColor="white" className="icon" />
            )
          }
        >
          <Typography color="inherit" type="s4">
            {message}
          </Typography>
        </StyledAlert>
      </Snackbar>
    </>
  );
};

export { Toast };
export default Toast;
